import { memo, useEffect, useState, FC } from "react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Textarea,
} from "@chakra-ui/react";

type Props = {
  object: Object | undefined;
  isOpen: boolean;
  onClose: () => void;
};

export const ObjectTypeModal: FC<Props> = memo((props) => {
  const { isOpen, onClose, object } = props;

  useEffect(() => {
    onModalReset();
  }, [object]);

  const onModalReset = () => {
    if (object) {
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onModalReset();
        onClose();
      }}
      motionPreset="slideInBottom"
      autoFocus={false}
      size={"4xl"}
    >
      <ModalOverlay />
      <ModalContent pb={2}>
        <ModalHeader>Type状況</ModalHeader>
        <ModalCloseButton />
        <ModalBody mx={{ base: 0, md: 6 }}>
          <Textarea
            value={JSON.stringify(object, null, 2)}
            readOnly={true}
            rows={20}
            border="1px"
            borderColor={"gray.400"}
          />
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
});
